import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { apiLogin, apiRegister, apiMe, setToken, getToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // undefined = still checking, null = guest, object = logged in
  const [user, setUser] = useState(getToken() ? undefined : null);

  const load = useCallback(async () => {
    if (!getToken()) { setUser(null); return; }
    try {
      const { user } = await apiMe();
      setUser(user);
    } catch (_) {
      setToken(null);
      setUser(null);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const login = async (email, password) => {
    const d = await apiLogin({ email, password });
    setToken(d.token); setUser(d.user); return d;
  };
  const register = async (body) => {
    const d = await apiRegister(body);
    setToken(d.token); setUser(d.user); return d;
  };
  const logout = () => { setToken(null); setUser(null); };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, reload: load }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
